import React from 'react'
import { Link } from 'gatsby'

export const NavLink = ({ to, label, ...props }) => {
  const urlsplit = props.url && props.url.split('.com')
  // eslint-disable-next-line no-param-reassign
  to = to || (urlsplit && urlsplit[1])
  // eslint-disable-next-line no-param-reassign
  to = to || props.url || '/'
  return (
    <Link
      {...props}
      sx={{
        display: 'block',
        color: 'black',
        fontSize: 18,
        variant: 'links.nav',
        p: 3,
      }}
      to={to}
    >
      {label}
    </Link>
  )
}
